(function() {
	/**
	 * Renders sitemap page
	 * @param {Object} props - The Routing and page context and properties
	 * @returns {object} 	Promise with data (nav for menu, etc.)
	 */
	WebBaseAprovLV.renderSitemapPage = function(props) {
		var params = {
			page: props.context.params.page || '',
			detail: props.context.params.detail || ''
		};
		var model = {
			element: null,
			template: 'templates/sitemap.ejs.html?v=' + WebBaseAprovLV.version.template,
			data: {
				main: (props.context.Model || {}).Main || {}, /* Comes from renderMainContent() */
				pageRaw: null,
				pageContent: null
			}
		};
		return $.when(
			WebBaseAprovLV.Utils.getKKData('?system.type=page&elements.url[in]=' + params.page + '&depth=1'),
			ejs.preloadTemplate(model.template),
			ejs.preloadTemplate('templates/breadcrumb.ejs.html?v=' + WebBaseAprovLV.version.template),
			ejs.preloadTemplate('templates/bottomnav.ejs.html?v=' + WebBaseAprovLV.version.template)
		)
		.then(function(pageXhr, tmplPage, tmplBreadcrumb, tmplSidebar) {
			var pageRaw = Array.isArray(pageXhr) ? pageXhr[0] : (pageXhr || {});
			model.data.pageRaw = pageRaw;
			if (model.data.pageRaw) {
				model.element = $('#content');
				model.data = $.extend(model.data, {
					pageContent: WebBaseAprovLV.Utils.getKKViewModel(model.data.pageRaw)[0] || {}
				});

				return WebBaseAprovLV.Utils.transitionTo(model);
			}
			return $.Deferred().reject(model);
		}).promise();
	};
})();